﻿import "Fancybox";
import $ from "jquery";
import require from "require";
import features from "./features";

export default class MicrositeInline {
	constructor(microsite, bannerId) {
		this.microsite = microsite;
		this.bannerId = bannerId;

		const $banner = $(`#${bannerId}`);
		const $script = $banner.find(`script[data-id=${bannerId}]`);

		require("inlineContent");

		$("<div>")
			.attr("id", `ic${bannerId}`)
			.css("display", "none")
			.html($script.text().trim())
			.appendTo($banner.parent());

		$script.remove();

		const ic = $banner.data("ic");
		new Function(ic.init)();

		features(ic.features, bannerId);
		this.$content = $(`#ic${bannerId}`);
		this.$content.css("width", `${microsite.width}px`);
		this.$content.css("height", "100%");
	}

	show() {
		const _ = this;

		$.fancybox.open({
			content: _.$content,
			type: "html",
			baseClass: "ccs-fancybox-microsite-inline",
			smallBtn: false,
			touch: false,
			trapFocus: false,
			afterShow() {
				require("ElementQueries").init(_.$content.find(".ccs-cc-inline")[0]);
				_.slickRefreshOnResize();
				_.initBackGroundVideoAutoPlay();
				_.adjustFeatures();
				_.adjustHotspots();
			},
			afterClose() {
				$.ccsVideoPlayer.stopAllVideos();
				require("ElementQueries").detach(_.$content.find(".ccs-cc-inline")[0]);
			},
			beforeClose(instance, current) {
				_.suppressYoutubeAutoplay();
			}
		});
	}

	/*CCSDT-6841 - "autoplay won't work in Safari and Chrome if any of parents of video tag have any DOM manipulation*/
	/*the explicit trigger required*/
	initBackGroundVideoAutoPlay() {
		const _ = this,
			container = _.$content;

		if (ccs_util.isMobile())
			return;

		const $bgVideos = container.find(".ccs-cc-inline-feature-background").find("video");

		$bgVideos.each((i, video) => {
			video.play();
			video.muted = true;
		});
	}

	slickRefreshOnResize() {
		const _ = this,
			$container = _.$content;
		var $slickContainers = $container.find(".ccs-slick-slider");

		if ($slickContainers.length === 0)
			return;

		$(document).off("ccsBreakpointFired.campaign").on("ccsBreakpointFired.campaign", function () {
			$slickContainers.each(function () {
				const slick = $(this);
				slick.ccsSlick("setPosition");
			});
		});
	}

	// CCSDT-7495, https://stackoverflow.com/q/8318264
	suppressYoutubeAutoplay() {
		const _ = this,
			$container = _.$content;

		if (ccs_util.isMobile()) {
			return;
		}

		$container.find("[data-video-url*='youtu']")
			.off(".ytCampaign")
			.one("ccsPlayer.ytCampaign", (e1) => {
				var $video = $(e1.target);
				var $wrap = $video.children(".ccs-cc-inline-embedded-video-wrapper");
				var player = e1.player;

				if (player.mejs.options.type === "video/youtube") {

					$video
						.off(".ytCampaign")
						.on("ccsPlayer.ytCampaign", (e2) => {
							if (e2.originalEvent.type === "canplay") {

								player.pause();
								$wrap.hide();

								$video.one("click.ytCampaign", () => {
									player.play();
									$wrap.show();
								});
							}
						});
				}
			});
	}

	adjustFeatures() {
		const _ = this,
			$content = _.$content;
		const $slickContainer = $content.find(".ccs-cc-fc-items");

		if (!$slickContainer.length)
			return;

		$slickContainer.each(function (e) {
			$(this).ccsSlick("setPosition");
		});
	}

	adjustHotspots() {
		const _ = this,
			$content = _.$content;

		if ($content.find(".ccs-cc-inline-hotspots").length === 0)
			return;

		$content.on("click", ".ccs-hotspots-point", function (e) {
			$content.on("scroll.qtip", function () {
				const $activePoint = $content.find(".ccs-hotspots-point.ccs-hotspots-point-active");
				let action = "reposition";
				if ($activePoint.length === 0 || !_.isElementInViewport($activePoint, 0, $content)) {
					action = "hide";
					$(this).off("scroll.qtip");
				}
				$activePoint.qtip(action);
			});
		});

		$content.on("click", e => {
			$content.find(".ccs-hotspots-point").not(e.target).qtip("hide");
		});

		$(document).on("beforeClose.ccs-fb", (e, instance, current) => {
			current.$content.find(".ccs-hotspots-point").qtip("hide");
			current.$content.off("scroll.qtip");
		});
	}

	isElementInViewport(element, spread, $viewportTag) {
		spread = spread || 0;

		const $element = $(element);
		if ($element.length === 0) {
			return false;
		}

		let windowsHeight = $(window).height();
		let viewportScrollTop = $(window).scrollTop();

		if ($viewportTag !== undefined) {
			viewportScrollTop += $viewportTag.offset().top;
			windowsHeight -= viewportScrollTop;
		}

		const areaTop = viewportScrollTop < spread ? 0 : viewportScrollTop - spread;
		const areaBottom = viewportScrollTop + windowsHeight + spread;

		const elementTop = $element.offset().top;
		const elementBottom = elementTop + $element.height();

		return elementBottom <= areaBottom
			&& elementTop >= areaTop
			&& $element.is(":visible");
	}
}
